<template>
  <div class="row">
    <div class="col-12 px-0">
      <h1 class="d-flex align-items-center">
        <span class="icon mr-2 icon-vorteile_rund_um_die_uhr" aria-hidden="true"></span>
        {{ $t('views.overbooked.title') }}
      </h1>
    </div>

    <link-back to="/" i18nMessage="common.backToOverview" />

    <loading-container :state="state" errorLinkTo="/holiday-list">
      <table class="table table-striped my-4" v-if="timeSlots.length > 0">
        <thead class="thead-dark">
          <tr>
            <th>{{ $t('views.overbooked.timeSlot') }}</th>
            <th>{{ $t('views.overbooked.room') }}</th>
            <th class="table-width-150">{{ $t('views.overbooked.ticketCount') }}</th>
            <th class="table-width-150">{{ $t('views.overbooked.capacity') }}</th>
            <th class="table-width-100">{{ $t('views.overbooked.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(timeSlot, index) in timeSlots" :key="index">
            <td>{{ formatTime(timeSlot) }}</td>
            <td>{{ timeSlot.roomName }}</td>
            <td class="table-width-150">{{ timeSlot.ticketCount }}</td>
            <td class="table-width-150">{{ timeSlot.capacity }}</td>
            <td class="table-width-100">
              <div class="d-flex justify-content-center aling-items-center">
                <link-default i18nMessage="common.timeSlotEdit" :to="{ name: 'admin-time-slot-edit', params: { roomId: timeSlot.roomId, timeSlotId: timeSlot.id } }" :iconOnly="true" iconClass="icon-editieren" class="align-self-center" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <feedback-message v-if="timeSlots.length === 0" :message="$t('views.overbooked.noTimeSlots')" />
    </loading-container>
  </div>
</template>

<script lang="ts">
import FeedbackMessage from '@/components/feedback/FeedbackMessage.vue'
import LinkBack from '@/components/interaction/LinkBack.vue'
import LinkDefault from '@/components/interaction/LinkDefault.vue'
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import { TimeSlot } from '@/generated/openapi'
import LoadingMixin from '@/mixins/LoadingMixin'
import { adminService } from '@/services/adminService'
import { now } from '@/utils/dateTimeUtils'
import { formatTicketTime } from '@/utils/formatUtils'
import { LoadingState } from '@/utils/loadingUtils'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Overbooked',
  mixins: [
    LoadingMixin
  ],
  components: {
    LoadingContainer,
    LinkBack,
    FeedbackMessage,
    LinkDefault
  },
  created() {
    adminService.findOverbookedTimeSlots().then(overbooked => {
      this.timeSlots = overbooked
    })
    this.state = LoadingState.success;
  },
  data() {
    return {
      timeSlots: [] as TimeSlot[],
      now: now().toISODate()
    }
  },
  methods: {
    formatTime(timeSlot: TimeSlot) {
      return formatTicketTime(timeSlot)
    }
  }
});
</script>
